import ExportDataLandingPage from './ExportDataLandingPage'

function ExportDataLayout() {
  return <ExportDataLandingPage />
}

export default ExportDataLayout
